import { render, staticRenderFns } from "./role-user.vue?vue&type=template&id=2c753ec3&scoped=true&"
import script from "./role-user.vue?vue&type=script&lang=js&"
export * from "./role-user.vue?vue&type=script&lang=js&"
import style0 from "./role-user.vue?vue&type=style&index=0&id=2c753ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c753ec3",
  null
  
)

export default component.exports